import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useRequestAccessStageStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '497px',
    ...shorthands.gap(tokens.spacingVerticalXXXL),
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingVerticalXXXL),
  },
  infoSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  logo: {
    display: 'flex',
    flexDirection: 'column',
    width: '192px',
    height: '192px',
    alignSelf: 'center',
  },
  title: {
    textAlign: 'center',
    marginBottom: '8px',
    marginTop: '0px',
    fontSize: '24px',
    fontWeight: 'bold',
    lineHeight: '32px',
    color: tokens.colorNeutralForeground1,
  },
  description: {
    fontSize: tokens.fontSizeBase400,
    color: tokens.colorNeutralForeground2,
  },
  companyPageContainer: {
    alignSelf: 'flex-start',
    width: '100%',
    backgroundColor: tokens.colorNeutralBackground1Pressed,
    ...shorthands.borderRadius(tokens.borderRadiusMedium),

    '& .company-page-item': {
      marginLeft: '16px',
      marginTop: '8px',
      marginBottom: '8px',
    },
  },
  actionsContainer: {
    display: 'flex',
    ...shorthands.gap(tokens.spacingVerticalS),
  },
});
